<template>
    <div class="container">
        <template v-if="!this.connection">
            <h2 class="title glowText">CONNECTING...</h2>
            <button v-on:click="reloadPage">Retry</button>
            <button v-on:click="stop">Stop</button>
        </template>
        <template v-else>

        </template>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        components: {
        },
        computed: {
            roomName () {
                return this.$route.params.roomName
            },
            ...mapGetters('NetworkInterface', [
                'connection',
            ]),
        },

        watch: {
            async connection(newVal) {
                console.log('update connection', newVal)
                if (newVal) {
                    console.log('request room info')
                    this.$store.dispatch('NetworkInterface/requestRoomInfo')
                    this.proceed()
                }
            },
        },

        mounted() {
            if (!this.connection) {
                this.$store.dispatch('NetworkInterface/joinRoom', { roomName: this.roomName })
            }
            else {
                this.proceed()
            }
        },

        methods: {
            navigateIfNeeded(location) {
                if (this.$route && location && this.$route.name === location.name) {
                    return
                }

                this.$router.push(location).catch((error) => {
                    if (error && error.name === 'NavigationDuplicated') {
                        return
                    }
                    throw error
                })
            },
            proceed() {
                if (this.connection) {
                    // this.$_routeAnimation('drilldown', this.ANIMATIONS.slideRight)
                    this.navigateIfNeeded({ name: this.Lobby.routes.Joined.name, params: { } })
                }
            },
            reloadPage() {
                window.location.reload()
            },
            stop () {
                this.$store.dispatch('NetworkInterface/resetSession')
                this.navigateIfNeeded({ name: this.Lobby.routes.Default.name, params: { } })
            }
        }
    }
</script>
